export const VIEW_ENTER = 'liveScores/VIEW_ENTER';
export const VIEW_LEAVE = 'liveScores/VIEW_LEAVE';
export const DETAILS_VIEW_ENTER = 'liveScores/DETAILS_VIEW_ENTER';
export const DETAILS_VIEW_LEAVE = 'liveScores/DETAILS_VIEW_LEAVE';
export const SET_EVENTS_DAY = 'liveScores/SET_EVENTS_DAY';
export const START_LIVE_EVENTS = 'liveScores/START_LIVE_EVENTS';
export const COMPETITION_VISIBLE = 'liveScores/COMPETITION_VISIBLE';

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const viewLeave = () => ({
  type: VIEW_LEAVE
});

export const detailsViewEnter = (day, eventId) => ({
  type: DETAILS_VIEW_ENTER,
  day,
  eventId
});

export const detailsViewLeave = () => ({
  type: DETAILS_VIEW_LEAVE
});

export const setEventsDay = day => ({
  type: SET_EVENTS_DAY,
  day
});

export const startLiveEvents = () => ({
  type: START_LIVE_EVENTS
});

export const competitionVisible = (id, visible) => ({
  type: COMPETITION_VISIBLE,
  id,
  visible
});
